/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function logout() {
	const navigate = useNavigate();
	useEffect(() => {
		localStorage.removeItem("token");
		navigate("/login");
	}, []);
	return <div>Loading...</div>;
}
